import styles from './About.module.css';

export function About() {
  return (
    <section className={styles.about} id="about">
      <h2>What is hey.sh</h2>
      <p>
        hey.sh is a workbench, not a platform. These modules are experiments in how people interact
        with intelligent systems. Some will evolve into products. Others exist to learn from.
      </p>
      <p>
        Built in the open. View the source on{' '}
        <a href="https://github.com/kpernyer/www.hey.sh" target="_blank" rel="noopener noreferrer">
          GitHub
        </a>
        .
      </p>
    </section>
  );
}
